import { div } from "framer-motion/client";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AdminLogin = () => {
	const [username, setUsername] = useState("");
	const [password, setPassword] = useState("");
	const [role, setRole] = useState("");
	const navigate = useNavigate();

	useEffect(() => {
		const adminUser = localStorage.getItem("Admin");
		const bloggerUser = localStorage.getItem("Blogger");

		if (adminUser || bloggerUser) {
			navigate("/AdminPanel", { replace: true });
		}
	}, [navigate]);

	const handleSubmit = (e) => {
		e.preventDefault();
		// Retrieve the stored user credentials from localStorage
		// const storedUser = JSON.parse(localStorage.getItem("Admin"));

		const User = {
			username: username,
			password: password,
			role: role,
		};
		// Store both users in localStorage
		console.log(`Current Role: ${role}`);
		if (role === "blogger") {
			localStorage.setItem("Blogger", JSON.stringify(User));
		} else if (role === "admin") {
			localStorage.setItem("Admin", JSON.stringify(User));
		}
		// alert(`Successfully Logged in as ${role}!`);
		navigate("/AdminPanel", { replace: true });
	};

	// Check if entered credentials match the stored credentials
	// if (
	//     storedUser.username.toLowerCase === username.toLowerCase &&
	//     storedUser.password.toLowerCase === password.toLowerCase &&
	//     storedUser.role.toLowerCase === role.toLowerCase
	// ) {
	//     navigate("/batmanAdminpanel/adminpanel");
	// } else {
	//     // If credentials do not match, show an error
	//     alert("Invalid credentials");
	// }
	// };

	return (
		<div>
			<div className="py-28">
				<div className="max-w-md  mx-auto  p-6 border border-gray-300 rounded-lg shadow-xl bg-white">
					<h2 className="text-2xl font-semibold text-left mb-4 mainred">
						Login
					</h2>
					<p className="text-gray-600 text-left mb-6">
						Enter your credentials to access your account.
					</p>
					<form onSubmit={handleSubmit} className="space-y-6">
						<div className="form-group">
							<label
								htmlFor="username"
								className="block text-sm font-medium text-gray-700"
							>
								Username/Email
							</label>
							<input
								type="text"
								id="username"
								placeholder="Enter your username or email"
								value={username}
								required
								onChange={(e) => setUsername(e.target.value)}
								className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:outline-none focus:ring-[2px] focus:ring-[#990000]"
							/>
						</div>
						<div className="form-group">
							<label
								htmlFor="password"
								className="block text-sm font-medium text-gray-700"
							>
								Password
							</label>
							<input
								type="password"
								id="password"
								placeholder="Enter your password"
								value={password}
								required
								onChange={(e) => setPassword(e.target.value)}
								className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[2px] focus:ring-[#990000]"
							/>
						</div>
						<div className="form-group">
							<label
								htmlFor="role"
								className="block text-sm font-medium text-gray-700"
							>
								Role
							</label>
							<select
								id="role"
								value={role}
								required
								onChange={(e) => setRole(e.target.value)}
								className="mt-1 cursor-pointer block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-[2px] focus:ring-[#990000]"
							>
								<option value="" disabled>
									Select Role
								</option>
								<option value="admin">Admin</option>
								<option value="blogger">Blog Writer</option>
							</select>
						</div>
						<button
							type="submit"
							className="w-full py-2 px-4 border border-transparent text-md font-medium rounded-md shadow-sm text-white mainredbg hover:!bg-[#b80202] focus:outline-none"
						>
							Login
						</button>
					</form>
				</div>
			</div>
		</div>
	);
};

export default AdminLogin;
